export const PlacementModeDropdown = [
  { id: 'merge', name: 'Merge' },
  { id: 'override', name: 'Override' }
]

export const PlacementModes = {
  merge: 'merge', override: 'override'
}



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Site/StaticData/PlacementModes.tsx